import Resource from '../Resource'

export default class WritingTest extends Resource {
  static ENDPOINT = '/api/test/writing/test'

  constructor (args) {
    super()
    if (args) {
      Object.keys(args).forEach(arg => {
        this[arg] = args[arg]
      })
    }
  }

  static create (training, type, subject, name, code, seq, test = []) {
    const testDate = new Date()
    return new WritingTest({ training, type, subject, name, code, seq, test, testDate })
  }
}
